import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Reservation } from '../classes/reservation';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class ReservationService {
    API_RESERVATION_URL = config.serverAddress + ':' + config.serverPort + '/reservation/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_RESERVATION_URL + 'all');
    }
    getGroupByIDInspection() {
        return this.http.get(this.API_RESERVATION_URL + 'inspection');
    }
    getByID(id: string) {
        return this.http.get(this.API_RESERVATION_URL + id);
    }
    getByIDInspection(idInspection: string) {
        return this.http.get(this.API_RESERVATION_URL + 'inspection/' + idInspection);
    }
    getByIdUserGroupByIdInspection(idUser?: string) {
        return this.http.get(this.API_RESERVATION_URL + 'inspection/user/' + idUser);
    }
    getByIDUser(idUser: string) {
        return this.http.get(this.API_RESERVATION_URL + 'user/' + idUser);
    }
    create(reservation: Reservation) {
        return this.http.post(this.API_RESERVATION_URL + 'create', reservation);
    }
    update(reservation: Reservation) {
        return this.http.put(this.API_RESERVATION_URL + 'update', reservation);
    }
    delete(id: number) {
        return this.http.delete(this.API_RESERVATION_URL + 'delete/' + id);
    }
}
